export default {
  // START:: GET APP THEME
  getAppTheme(state) {
    return state.glow_up_dashboard_theme;
  },
  // END:: GET APP THEME GETTER
};
